// src/AccountInfo.tsx
import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

const AccountInfo: React.FC = () => {
  const { user, logout } = useAuth0();

  return (
    <Container maxWidth="sm" sx={{ pt: 4, mb: 12 }}>
      <Typography variant="h5" gutterBottom>
        Account Information
      </Typography>
      <Box mt={2}>
        <Typography variant="body1">Name: {user?.name}</Typography>
        <Typography variant="body1">Email: {user?.email}</Typography>
        <Typography variant="body1">Nickname: {user?.nickname}</Typography>
      </Box>
      <Box mt={3}>
        <button
          onClick={() =>
            logout({
              logoutParams: {
                returnTo: window.location.origin
              }
            })
          }
        >
          Log Out
        </button>
      </Box>
    </Container>
  );
};

export default AccountInfo;
